// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: ct9kVdatV78GHhK9QiJ54N
// Component: WGvxyuKSa5t
import * as React from "react";
import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/host";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts
} from "@plasmicapp/react-web";
import MainPaymentsCta from "../../MainPaymentsCta"; // plasmic-import: UFDEOqO0nC/component
import Card from "../../Card"; // plasmic-import: Gc-TRbS8XX/component
import Wire from "../../Wire"; // plasmic-import: v5d6gts_S6/component
import Crypto from "../../Crypto"; // plasmic-import: VnGgrE4c19/component
import PaymentsPageSidebar from "../../PaymentsPageSidebar"; // plasmic-import: FaRlVP157fG/component
import "@plasmicapp/react-web/lib/plasmic.css";
import projectcss from "./plasmic_astriusdraft.module.css"; // plasmic-import: ct9kVdatV78GHhK9QiJ54N/projectcss
import sty from "./PlasmicPaymentsPagePreview.module.css"; // plasmic-import: WGvxyuKSa5t/css
import Icon4Icon from "./icons/PlasmicIcon__Icon4"; // plasmic-import: dPI1wV3OoH/icon
import Line2Icon from "./icons/PlasmicIcon__Line2"; // plasmic-import: InwQcdozxk/icon
import Line1Icon from "./icons/PlasmicIcon__Line1"; // plasmic-import: t-tWHZTgfh/icon

export const PlasmicPaymentsPagePreview__VariantProps = new Array();

export const PlasmicPaymentsPagePreview__ArgProps = new Array(
  "merchantName",
  "escrowDeposit",
  "milestoneOrContract",
  "footerText",
  "sendText"
);

export const defaultPaymentsPagePreview__Args = {};

function PlasmicPaymentsPagePreview__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = Object.assign({}, defaultPaymentsPagePreview__Args, props.args);
  const $props = args;
  const $ctx = ph.useDataEnv?.() || {};
  return (
    <React.Fragment>
      <div className={projectcss.plasmic_page_wrapper}>
        <div
          data-plasmic-name={"root"}
          data-plasmic-override={overrides.root}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          className={classNames(
            projectcss.all,
            projectcss.root_reset,
            projectcss.plasmic_default_styles,
            projectcss.plasmic_mixins,
            sty.root
          )}
        >
          <div className={classNames(projectcss.all, sty.freeBox__cyMsJ)}>
            <Icon4Icon
              data-plasmic-name={"goBackArrow"}
              data-plasmic-override={overrides.goBackArrow}
              className={classNames(projectcss.all, sty.goBackArrow)}
              role={"img"}
            />

            <div
              data-plasmic-name={"goBackText"}
              data-plasmic-override={overrides.goBackText}
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.goBackText
              )}
            >
              {"Go Back"}
            </div>

            <div
              data-plasmic-name={"sendButton"}
              data-plasmic-override={overrides.sendButton}
              className={classNames(projectcss.all, sty.sendButton)}
            >
              <div
                data-plasmic-name={"sendText"}
                data-plasmic-override={overrides.sendText}
                className={classNames(projectcss.all, sty.sendText)}
              >
                {p.renderPlasmicSlot({
                  defaultContents: "Send",
                  value: args.sendText,
                  className: classNames(sty.slotTargetSendText)
                })}
              </div>
            </div>
          </div>

          <div
            data-plasmic-name={"previewBody"}
            data-plasmic-override={overrides.previewBody}
            className={classNames(projectcss.all, sty.previewBody)}
          >
            <div className={classNames(projectcss.all, sty.freeBox__yI8D)}>
              <div
                data-plasmic-name={"companyName"}
                data-plasmic-override={overrides.companyName}
                className={classNames(projectcss.all, sty.companyName)}
              >
                {p.renderPlasmicSlot({
                  defaultContents: "Vayner Media",
                  value: args.merchantName,
                  className: classNames(sty.slotTargetMerchantName)
                })}
              </div>

              <div
                data-plasmic-name={"rectangle29"}
                data-plasmic-override={overrides.rectangle29}
                className={classNames(projectcss.all, sty.rectangle29)}
              >
                <div
                  data-plasmic-name={"figmaPaste"}
                  data-plasmic-override={overrides.figmaPaste}
                  className={classNames(projectcss.all, sty.figmaPaste)}
                >
                  <div
                    className={classNames(projectcss.all, sty.freeBox___8U9FU)}
                  >
                    {p.renderPlasmicSlot({
                      defaultContents: (
                        <div
                          className={classNames(
                            projectcss.all,
                            projectcss.__wab_text,
                            sty.text__h6Ufp
                          )}
                        >
                          {"Requested Escrow Deposit: $900.00"}
                        </div>
                      ),

                      value: args.escrowDeposit,
                      className: classNames(sty.slotTargetEscrowDeposit)
                    })}
                  </div>

                  <div
                    className={classNames(projectcss.all, sty.freeBox__xjoTg)}
                  >
                    {p.renderPlasmicSlot({
                      defaultContents:
                        "Milestone 1: Initial Setup as jkkja asdf rarfaffaeerrfa. ",
                      value: args.milestoneOrContract,
                      className: classNames(sty.slotTargetMilestoneOrContract)
                    })}
                  </div>

                  <Line2Icon
                    className={classNames(projectcss.all, sty.svg__si9Jw)}
                    role={"img"}
                  />

                  <div
                    data-plasmic-name={"viewDetails"}
                    data-plasmic-override={overrides.viewDetails}
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.viewDetails
                    )}
                  >
                    {"View Full Contract Details  >"}
                  </div>
                </div>
              </div>

              <div
                data-plasmic-name={"rectangle28"}
                data-plasmic-override={overrides.rectangle28}
                className={classNames(projectcss.all, sty.rectangle28)}
              >
                <div
                  data-plasmic-name={"figmaPaste2"}
                  data-plasmic-override={overrides.figmaPaste2}
                  className={classNames(projectcss.all, sty.figmaPaste2)}
                >
                  <MainPaymentsCta
                    data-plasmic-name={"mainPaymentsCta"}
                    data-plasmic-override={overrides.mainPaymentsCta}
                    className={classNames(
                      "__wab_instance",
                      sty.mainPaymentsCta
                    )}
                  />

                  <Line1Icon
                    className={classNames(projectcss.all, sty.svg__r01Mt)}
                    role={"img"}
                  />

                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__tVfmz
                    )}
                  >
                    {"Or fund the escrow a different way"}
                  </div>

                  <Card
                    data-plasmic-name={"card"}
                    data-plasmic-override={overrides.card}
                    className={classNames("__wab_instance", sty.card)}
                  />

                  <Wire
                    data-plasmic-name={"wire"}
                    data-plasmic-override={overrides.wire}
                    className={classNames("__wab_instance", sty.wire)}
                  />

                  <Crypto
                    data-plasmic-name={"crypto"}
                    data-plasmic-override={overrides.crypto}
                    className={classNames("__wab_instance", sty.crypto)}
                  />

                  <div
                    className={classNames(projectcss.all, sty.freeBox__zwUn)}
                  />
                </div>
              </div>

              <div
                data-plasmic-name={"figmaPaste3"}
                data-plasmic-override={overrides.figmaPaste3}
                className={classNames(projectcss.all, sty.figmaPaste3)}
              >
                <div className={classNames(projectcss.all, sty.freeBox__e3HR)}>
                  {p.renderPlasmicSlot({
                    defaultContents:
                      "Your funds will be safeguarded until Vayner Media has delivered their service according to the contract terms.",
                    value: args.footerText,
                    className: classNames(sty.slotTargetFooterText)
                  })}
                </div>

                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__m8BR0
                  )}
                >
                  {"Powered by astrius"}
                </div>
              </div>
            </div>

            <PaymentsPageSidebar
              data-plasmic-name={"paymentsSideBar"}
              data-plasmic-override={overrides.paymentsSideBar}
              className={classNames("__wab_instance", sty.paymentsSideBar)}
              contractName={"Social Media Marketing"}
            />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

const PlasmicDescendants = {
  root: [
    "root",
    "goBackArrow",
    "goBackText",
    "sendButton",
    "sendText",
    "previewBody",
    "companyName",
    "rectangle29",
    "figmaPaste",
    "viewDetails",
    "rectangle28",
    "figmaPaste2",
    "mainPaymentsCta",
    "card",
    "wire",
    "crypto",
    "figmaPaste3",
    "paymentsSideBar"
  ],

  goBackArrow: ["goBackArrow"],
  goBackText: ["goBackText"],
  sendButton: ["sendButton", "sendText"],
  sendText: ["sendText"],
  previewBody: [
    "previewBody",
    "companyName",
    "rectangle29",
    "figmaPaste",
    "viewDetails",
    "rectangle28",
    "figmaPaste2",
    "mainPaymentsCta",
    "card",
    "wire",
    "crypto",
    "figmaPaste3",
    "paymentsSideBar"
  ],

  companyName: ["companyName"],
  rectangle29: ["rectangle29", "figmaPaste", "viewDetails"],
  figmaPaste: ["figmaPaste", "viewDetails"],
  viewDetails: ["viewDetails"],
  rectangle28: [
    "rectangle28",
    "figmaPaste2",
    "mainPaymentsCta",
    "card",
    "wire",
    "crypto"
  ],

  figmaPaste2: ["figmaPaste2", "mainPaymentsCta", "card", "wire", "crypto"],
  mainPaymentsCta: ["mainPaymentsCta"],
  card: ["card"],
  wire: ["wire"],
  crypto: ["crypto"],
  figmaPaste3: ["figmaPaste3"],
  paymentsSideBar: ["paymentsSideBar"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = deriveRenderOpts(props, {
      name: nodeName,
      descendantNames: [...PlasmicDescendants[nodeName]],
      internalArgPropNames: PlasmicPaymentsPagePreview__ArgProps,
      internalVariantPropNames: PlasmicPaymentsPagePreview__VariantProps
    });

    return PlasmicPaymentsPagePreview__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicPaymentsPagePreview";
  } else {
    func.displayName = `PlasmicPaymentsPagePreview.${nodeName}`;
  }
  return func;
}

export const PlasmicPaymentsPagePreview = Object.assign(
  // Top-level PlasmicPaymentsPagePreview renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    goBackArrow: makeNodeComponent("goBackArrow"),
    goBackText: makeNodeComponent("goBackText"),
    sendButton: makeNodeComponent("sendButton"),
    sendText: makeNodeComponent("sendText"),
    previewBody: makeNodeComponent("previewBody"),
    companyName: makeNodeComponent("companyName"),
    rectangle29: makeNodeComponent("rectangle29"),
    figmaPaste: makeNodeComponent("figmaPaste"),
    viewDetails: makeNodeComponent("viewDetails"),
    rectangle28: makeNodeComponent("rectangle28"),
    figmaPaste2: makeNodeComponent("figmaPaste2"),
    mainPaymentsCta: makeNodeComponent("mainPaymentsCta"),
    card: makeNodeComponent("card"),
    wire: makeNodeComponent("wire"),
    crypto: makeNodeComponent("crypto"),
    figmaPaste3: makeNodeComponent("figmaPaste3"),
    paymentsSideBar: makeNodeComponent("paymentsSideBar"),
    // Metadata about props expected for PlasmicPaymentsPagePreview
    internalVariantProps: PlasmicPaymentsPagePreview__VariantProps,
    internalArgProps: PlasmicPaymentsPagePreview__ArgProps
  }
);

export default PlasmicPaymentsPagePreview;
/* prettier-ignore-end */
